import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(LanguageDetector).init({
    resources: {
        en: {
            translations: {
                // Intro
                intro: {
                    title: 'Clockwork - Web and Mobile Application Development',
                    studio: 'Web Studio',
                    heading: {
                        text: 'Every our project',
                        is: 'is the'
                    },
                    presentation: {
                        link: 'Download our presentation',
                        text: 'We are making things for'
                    },
                    words: {
                        marketing: 'Marketing',
                        design: 'Design',
                        development: 'Development',
                        analytics: 'Analytics'
                    }
                },
                // Feedback
                feedback: {
                    title: 'Get in touch',
                    description: 'Want to get a free consultation on the development of your future project?',
                    call: 'Fill out a from or call us',
                    form: {
                        name: 'Name',
                        phone: 'Phone',
                        email: 'E-mail',
                        comment: 'Comment',
                        submit: 'Discuss the Project'
                    },
                    notification: {
                        success: 'Ваше заявка успешно отправлена! В ближайщее время с Вами свяжется наш менеджер',
                        error: 'Во время отправки заявки произошла ошибка! Пожалуйста, попробуйте отправить заявку позже',
                        phone: 'Phone number is invalid',
                        email: 'E-mail address in invalid'
                    }
                },
                // Service
                service: {
                    website: {
                        name: 'Websites',
                        items: {
                            landingPage: 'Landing Page',
                            corporateWebsite: 'Corporate Website',
                            eCommerce: 'E-Commerce'
                        }
                    },
                    mobile: {
                        name: 'Mobile<br />Applications',
                        items: {
                            social: 'Social',
                            eCommerce: 'E-Commerce',
                            enterprise: 'Enterprise'
                        }
                    },
                    branding: {
                        name: 'Branding',
                        items: {
                            design: 'Design',
                            ui: 'UI/UX',
                            id: 'Naming'
                        }
                    },
                    ads: {
                        name: 'Advertising',
                        items: {
                            seo: 'SEO',
                            smm: 'SMM',
                            context: 'Contextual Advertising'
                        }
                    }
                },
                and: 'and',
                // Cookie
                'cookie-text': 'We use cookie!',
                'cookie-link': 'What does that mean?',
                'cookie-h1': 'How Clockwork uses cookie',
                'cookie-how-we-use': 'Just like most websites, Clockwork uses cookies, which give us the opportunity to render services to our customers, see that our services are available and have not failed, as well as analyze data and understand what we are doing wrong, and how we should proceed with developing our service and products. In this document, we explain how we use cookies, and what customers can do about it (if they want).',
                'cookie-what-is': 'What are cookies?',
                'cookie-what-is-text': 'For some reason, the British call them "biscuits". But Internet cookies are slightly different. A cookie is a data fragment from a website you have visited that is stored on your computer.',
                'cookie-what-we-use': 'Which cookies do we use and why?',
                'cookie-what-we-use-text': 'Statistics cookies: we use several systems to collect statistics, as it is important for us to know how people read us. Based on this data, we can understand the size of our audience, and what we are doing right or wrong. We collect statistics through our partners: Google Analytics and Yandex Metrika.',
                'cookie-if-dont-want-use': 'What should you do if you don\'t want to use cookies?',
                'cookie-if-dont-want-use-text': 'You can disable them using your browser\'s security settings. An important note: the settings should be applied to all browsers you use (both on your computer and smartphone). If you choose to disable cookies, please note that some Clockwork services will no longer be available to you, or may operate unpredictably.',
                'cookie-learn-more': 'How do you learn more?',
                'cookie-learn-more-text': 'Write us a letter!',
                // Common
                'Clockwork': 'Clockwork',
                'Service': 'Service',
                'Our Works': 'Our Works',
                'Estimate': 'Estimate',
                'Contacts': 'Contacts',
                // Projects
                issue: 'Issue',
                solve: 'Solve',
                before: 'Before',
                after: 'After',
                cover: 'CD Cover',
                businessCards: 'Business Cards',
                smm: 'Social Networking',
                flier: 'Flier',
                // DS
                ds: {
                    name: 'Direct Scouting Center',
                    text1: 'Recruiting agency from Moscow, working in close collaboration with leading Western and Asian posts.',
                    text2: 'Behind the DSC there are many shootings in Milan, Paris, New York and London.',
                    issue: 'To develop an adaptive website capable of processing applications of potential models, with the ability to place their portfolio on their own resource with one click.',
                    solve: 'We made the site for the booking agency Direct Scouting Center available on all types of devices and provided interaction between models and applicants.'
                },
                // Tommy
                tommy: {
                    name: 'Tommy House - virtual bonus card',
                    text1: 'Tommy House is a bar of the rising sun in the very center of Krasnoyarsk.',
                    issue: 'The new institution needs to introduce a loyalty program, given that the target audience is young people, active users of mobile devices, it was decided to develop a mobile application.',
                    solve1: 'We have developed a mobile application for visitors to the institution with the possibility of registration in the loyalty program.',
                    solve2: 'The user has access to the history of accrual and deduction of bonus points, as well as information about the transition from stage to stage and the current status of the participant.'
                },
                pp: {
                    name: 'PlusPatch is transdermal vitamin patches',
                    text1: 'PlusPatch is Russia\'s first transdermal vitamin patches.',
                    issue: 'Given the fact that the transdermal way of taking vitamins in Russia is a completely new and unusual phenomenon, we were faced with the task of introducing the consumer to a new product and helping to choose the right product.',
                    solve: 'To familiarize the consumer with the product, we developed Quiz, according to the results of which the site visitor is given recommendations on the intake of vitamin patches.'
                },
                // MU
                mu: {
                    name: 'Medunion - medical centers',
                    text1: 'The network of medical centers Medunion in the market of paid medical services for more than 10 years. High-precision diagnostic equipment and qualified staff make the clinic competitive for a very long time.',
                    text2: 'The centers are located in 2 cities of the Krasnoyarsk Territory: Krasnoyarsk and Kansk.',
                    issue: 'We had 2 tasks: to create a new visual image of the clinic, based on the idea of the previous logo, as well as to divide medical centers according to the area of belonging and develop a new corporate website.',
                    solve: 'Our team has created a new logo design and corporate identity approach that meets modern trends and the requirements of the digital industry. This allowed the brand to position itself favorably on social networks and the web.'
                },
                // DM
                dm: {
                    name: 'DomAvtomatika - boiler control system',
                    text1: 'DomAvtomatika is a product developed by PinTwo, a company of young engineers. The company is developing smart home and smart city systems.',
                    issue: 'The company has developed a new DM-350 boiler controller that allows remote control through a mobile application.',
                    solve: 'We have developed a mobile application for which the user can: adjust the temperature of the boiler, set the schedule, view statistics of temperature and fuel consumption.'
                },
                // Contacts
                contacts: {
                    city: 'Krasnoyarsk',
                    street: 'Partizana Zheleznyaka 19d, 201',
                    inn: 'INN',
                    ogrn: 'OGRN'
                }
            }
        },
        ru: {
            translations: {
                // Intro
                intro: {
                    title: 'Clockwork - разработка сайтов и мобильных приложений',
                    studio: 'Веб-студия',
                    heading: {
                        text: 'Каждый наш проект',
                        is: 'это &mdash;'
                    },
                    presentation: {
                        link: 'Скачать презентацию проектов',
                        text: 'Разработка для'
                    },
                    words: {
                        marketing: 'Маркетинг',
                        design: 'Дизайн',
                        development: 'Разработка',
                        analytics: 'Аналитика'
                    }
                },
                // Feedback
                feedback: {
                    title: 'Свяжитесь с нами',
                    description: 'Хотите получить бесплатную консультацию о разработке вашего будущего проекта?',
                    call: 'Заполните заявку или позвоните нам',
                    form: {
                        name: 'Имя',
                        phone: 'Телефон',
                        email: 'E-mail',
                        comment: 'Комментарий',
                        submit: 'Обсудить проект'
                    },
                    notification: {
                        success: 'Ваше заявка успешно отправлена! В ближайщее время с Вами свяжется наш менеджер',
                        error: 'Во время отправки заявки произошла ошибка! Пожалуйста, попробуйте отправить заявку позже',
                        phone: 'Неправильно указан номер телефона',
                        email: 'Неправильно указан E-mail адрес'
                    }
                },
                // Service
                service: {
                    website: {
                        name: 'Веб-сайты',
                        items: {
                            landingPage: 'Лендинг пейдж',
                            corporateWebsite: 'Корпоративные сайты',
                            eCommerce: 'Электронная коммерция'
                        }
                    },
                    mobile: {
                        name: 'Мобильные<br />приложения',
                        items: {
                            social: 'Социальные',
                            eCommerce: 'Электронная коммерция',
                            enterprise: 'Корпоративные'
                        }
                    },
                    branding: {
                        name: 'Брендинг',
                        items: {
                            design: 'Дизайн',
                            ui: 'Интерфейсы',
                            id: 'Нэйминг'
                        }
                    },
                    ads: {
                        name: 'Реклама',
                        items: {
                            seo: 'SEO',
                            smm: 'SMM',
                            context: 'Контекстная реклама'
                        }
                    }
                },
                and: 'и',
                before: 'До',
                after: 'После',
                cover: 'Обложка для диска',
                businessCards: 'Визитки',
                smm: 'Оформление социальных сетей',
                flier: 'Листовка',
                // Cookie
                'cookie-text': 'Мы используем cookie!',
                'cookie-link': 'Что это значит?',
                'cookie-h1': 'Как «Клокворк» использует cookie',
                'cookie-how-we-use': '«Клокворк», как и большинство сайтов в интернете, использует cookie: это дает нам возможность предоставлять клиентам свои услуги, следить за тем, что наши сервисы доступны и не упали, а также анализировать данные и понимать, что мы делаем не так и куда развивать наши продукты и услуги. В этом документе мы объясняем, как мы используем cookie — и что посетители могут в связи с этим предпринять (если захотят).',
                'cookie-what-is': 'Что такое cookie?',
                'cookie-what-is-text': 'В целом это печенье. Но не в нашем случае. Cookie — это фрагмент данных сайта, на который вы зашли и который сохраняется на вашем компьютере.',
                'cookie-what-we-use': 'Какие cookiе мы используем и с какой целью?',
                'cookie-what-we-use-text': 'Cookie для статистики: мы используем несколько систем для сбора статистики — нам важно знать, как нас просматривают. На основе этих данных мы понимаем размер нашей аудитории, а также что мы делаем правильно и что неправильно. Мы осуществляем сбор статистики через партнеров — Google Analytics и Yandex Metrika.',
                'cookie-if-dont-want-use': 'Что делать, если вы не хотите использовать cookie?',
                'cookie-if-dont-want-use-text': 'Вы можете отключить их в настройках безопасности вашего браузера. Важно понимать, что настройки нужно применить во всех браузерах, которыми вы пользуетесь (на компьютере и в телефоне). В случае если вы решите отключить cookiе, имейте в виду, что часть функций сервисов «Клокворк» перестанут быть вам доступны или могут работать непредсказуемо.',
                'cookie-learn-more': 'Как узнать больше подробностей?',
                'cookie-learn-more-text': 'Написать нам.',
                // Common
                'Clockwork': 'Клокворк',
                'Service': 'Услуги',
                'Our Works': 'Проекты',
                'Estimate': 'Калькулятор',
                'Contacts': 'Контакты',
                // Projects
                issue: 'Задача',
                solve: 'Решение',
                // DS
                ds: {
                    name: 'Direct Scouting Center',
                    text1: 'Рекрутинговое агенство из Москвы, работающее в тесном сотрудничестве с ведущими западными и азиатскими партнерами.',
                    text2: 'За плечами DSC множество съемок в Милане, Париже, Нью-Йорке и Лондоне.',
                    issue: 'Разработать адаптивный сайт, способный обрабатывать заявки потенциальных моделей, с возможностью в один клик разместить их портфолио на собственном ресурсе.',
                    solve: 'Мы сделали сайт для букингового агенства Direct Scouting Center доступным на всех типах устройств и обеспечили взаимодействие между моделями и соискателями.'
                },
                // MU
                mu: {
                    name: 'Медюнион - сеть медецинских центров',
                    text1: 'Сеть медицинских центров Медюнион на рынке платных медицинских услуг уже более 10 лет. Высокоточное диагностическое оборудование и квалифицированный персонал делают клинику конкурентной на протяжении очень долгого времни.',
                    text2: 'Центры расположены в 2-х городах Красноярского Края: Красноярск и Канск.',
                    issue: 'Перед нами стояло 2 задачи: создать новый визуальный образ клиники, опираясь на идею предидущего логотипа, а так же разделить медицинские центры по районой пренадлежности и разработать новый корпоративный сайт.',
                    solve: 'Наша команда создала новый дизайн логотипа и подход к фирменному стилю отвечающий современным тенденциям, и требованиям диджитал индустрии. Это позволило бренду выгодно позиционировать себя в социальных сетях и вебе.'
                },
                // Tommy
                tommy: {
                    name: 'Tommy House - виртуальная бонусная карта',
                    text1: 'Tommy House - бар восходящего солнца в самом ценре Красноярска.',
                    issue: 'Новому заведению необходимо ввести программу лояльности, учитывая что целевая аудитория молодые люди, активные пользователи мобильных устройств, было принято решение разработать мобильное приложение.',
                    solve1: 'Мы разработали для посетителей заведения мобильное приложение с возможностью регистрации в программе лояльности.',
                    solve2: 'Пользователю доступна история начисления и списания бонусных баллов, а также к информация о переходе с этапа на этап и текущему статусу участника.'
                },
                // PP
                pp: {
                    name: 'PlusPatch - трансдермальные витаминные патчи',
                    text1: 'PlusPatch - первые в России трансдермальные витаминные патчи.',
                    issue: 'Учитывая тот факт, что трансдермальный способ приема витаминов в Росиии - это совершенно новое и непривычное явление, перед нами стояла задача познакомить потребителя с новым продуктом, и помочь выбрать нужный продукт.',
                    solve: 'Для знакомства потребителя с продуктом  мы разработали Quiz, по результатам которго посетителю сайта выдаются рекомендации по приему витаминных патчей.'
                },
                // DM
                dm: {
                    name: 'ДомАвтоматика - сиситема управления котлом',
                    text1: 'ДомАвтоматика - это продукт, разработанный компанией молодых инженеров PinTwo. Компания разрабатывает системы умного дома и умного города.',
                    issue: 'Компания разработала новый контроллер управления отопительными котлами DM-350, позволяющий удаленное управление через мобильное приложение.',
                    solve: 'Мы разработали для мобильное приложение, в котором пользователь может: регулировать температуру котла, настраивать расписание работы, просматривать статистику температуры и расхода топлива.'
                },
                // Contacts
                contacts: {
                    city: 'Красноярск',
                    street: 'ул. Партизана Железняка 19д, 201',
                    inn: 'ИНН',
                    ogrn: 'ОГРН'
                }
            }
        }
    },
    fallbackLng: 'en',
    debug: false,

    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: '.',

    interpolation: {
        escapeValue: false,
        formatSeparator: ','
    },

    react: {
        wait: true
    }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js